
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12.81 11a5.5 5.5 0 012.31 9.159l-3.241 3.24A5.5 5.5 0 014.1 15.622l3.24-3.24a5.484 5.484 0 011.78-1.192"}}),_c('path',{attrs:{"d":"M14.685 16.507a5.5 5.5 0 01-2.31-9.159l3.24-3.241a5.5 5.5 0 017.778 7.778l-3.24 3.24a5.484 5.484 0 01-1.78 1.193"}})]),_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","d":"M27 21.429v1.142a.571.571 0 01-.571.572h-2.286v2.286a.571.571 0 01-.572.571H22.43a.571.571 0 01-.572-.571v-2.286h-2.286A.571.571 0 0119 22.57V21.43c0-.316.256-.572.571-.572h2.286v-2.286c0-.315.256-.571.572-.571h1.142c.316 0 .572.256.572.571v2.286h2.286c.315 0 .571.256.571.572z"}})])])
          )
        }
      }
    